export default __webpack_public_path__ + "static/media/cafe_2.e53d6824.jpg";